var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('default-system-bar'),_c('default-bar'),_c('default-drawer'),_c('default-fab-to-top'),_c('default-view'),_c('default-toc'),_c('default-snackbar'),_c('default-pwa-snackbar'),_c('default-settings')],1)}
var staticRenderFns = []

export { render, staticRenderFns }